import Cookies from 'js-cookie';
import actions from './actions';
import { DataService } from '../../config/dataService/dataService';

const { loginSuccess, logoutSuccess } = actions;

const generic500Error = 'Internal Server Error';

const login = data => {
  return async dispatch => {
    try {
      const response = await DataService.post('/auth/login.php', data);
      if (response.status === 200) {      
        var in60Minutes = 1/24;  
        Cookies.set('dcare_access_token', response.data.token, {
          expires: in60Minutes
      });
        Cookies.set('dcare_logedIn', true, {
          expires: in60Minutes
      });
        Cookies.set('dcare_user', JSON.stringify(response.data.data), {
          expires: in60Minutes
      });
        dispatch(loginSuccess(true));
        return true;
      }
      return false;
    } catch (err) {
      alert(generic500Error);
    }
    return false;
  };
};

const logOut = () => {
  return async dispatch => {
    Cookies.remove('dcare_logedIn');
    Cookies.remove('dcare_access_token');
    Cookies.remove('dcare_user');
    dispatch(logoutSuccess(null));
  };
};

export { login, logOut, };
